import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import themeColor from './hooks/ThemeColor';

function Navbar() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomepage = location.pathname === '/';
  let theme = themeColor(isMenuOpen);
  const bodyDiv = document.getElementById('body-div');

  useEffect(() => {
    if (isMenuOpen || isHomepage) {
      document.body.style.overflow = 'hidden';
      bodyDiv.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
      bodyDiv.style.overflow = 'unset';
    }

    const logo = document.getElementById('logo');
    if (isHomepage) {
      logo.style.visibility = 'hidden';
    } else {
      logo.style.visibility = 'visible';
    }

    return () => {
      document.body.style.overflow = 'unset';
      bodyDiv.style.overflow = 'unset';
    };
  }, [isMenuOpen, isHomepage]);

  const handleMenuItemClick = () => {
    setIsMenuOpen(false);
  };

  const menuItems = [
    { label: 'Home', sublabel: '/', count: 'I' },
    { label: 'Studio', sublabel: '/about', count: 'II' },
    { label: "Let's Talk", sublabel: '/contact', count: 'I' }
  ];

  return (
    <div>

      <nav className={isHomepage ? 'home-nav' : ''}>
        <div id="logo">Manik</div>
        <button
            onClick={() => setIsMenuOpen(true)}
            className="px-6 py-2 border border-slate-400/60 rounded-full text-slate-700 hover:bg-slate-300/50 transition-all duration-300 font-light tracking-wide"
          >
            MENU
          </button>
      </nav>

      {/* menu overlay */}
      <div className={`fixed inset-0 z-[100] transition-all duration-700 ease-out w-full h-full ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'} menu`}>
        {/* background */}
        <div className="nav-background absolute inset-0 bg-slate-800 h-full"></div>

        {/* nav links */}
        <div className={`absolute top-0 w-full h-full flex items-center justify-center transition-all duration-1000 ease-out delay-200 ${isMenuOpen ? 'transform translate-x-0 opacity-100' : 'transform translate-x-full opacity-0'}`}>
          <div className="space-y-12">
            {menuItems.map((item, index) => (
              <div
                key={item.label}
                className={`transition-all duration-500 ease-out ${isMenuOpen ? 'transform translate-y-0 opacity-100' : 'transform translate-y-8 opacity-0'} nav-links`}
                style={{ transitionDelay: `${300 + index * 100}ms` }}
              >
                <button className="text-2xl md:text-3xl text-white font-light hover:text-blue-200 transition-colors duration-300 block" onClick={handleMenuItemClick}>
                  <span className="nav-count">{item.count}</span>
                  <Link to={item.sublabel}>{item.label}</Link>
                </button>
              </div>
            ))}

              <div className={`text-center space-x-8 pt-12 transition-all duration-500 ease-out ${isMenuOpen ? 'transform translate-y-0 opacity-100' : 'transform translate-y-8 opacity-0'} socials`}
              style={{ transitionDelay: '800ms' }}>
                <a href="https://www.linkedin.com/company/manik-studio-la" className="transition-colors duration-300 text-sm tracking-wide">
                  LinkedIn
                </a>
                <a href="mailto:rachel@manik-studio.com?subject=Manik Studio: Let's work together" className="transition-colors duration-300 text-sm tracking-wide">
                  Email
                </a>
            </div>

          </div>
        </div>

        <button
          onClick={() => setIsMenuOpen(false)}
          className={`absolute top-8 right-8 text-white/80 hover:text-white transition-all duration-300 ${isMenuOpen ? 'opacity-100 rotate-0' : 'opacity-0 rotate-45'}`}
          style={{ transitionDelay: isMenuOpen ? '400ms' : '0ms' }}
        >
          <div className="px-4 py-2 border border-white/30 rounded-full text-sm tracking-wide">
            CLOSE ×
          </div>
        </button>
      </div>

  </div>

  );
}

export default Navbar;